module.exports = __webpack_public_path__ + "img/ic_carteira.4a654ca0.svg";